import React, {Component} from 'react';
import {HashRouter, Switch} from "react-router-dom";
import {Dashboard} from 'react-adminlte-dash';
import {Footer} from "./component/Footer/Footer";
import {AllRoutes} from "./Routes";
import MySidebar, { SIDEBAR_COLLAPSE_STORAGE } from "./component/Sidebar/MySidebar";
import NavHeader from "./component/Navbar/NavHeader";
import AuthenticationService from "./services/AuthenticationService";
import PrivateRoute from "./component/Routes/PrivateRoute";
import "./App.css";
import "./styles/bootstrap-custom.css";
import {ToastContainer} from "react-toastify";
import UserService from "./services/UserService";
import Notify from "./services/Notify";
import Loading from "./component/Loading/Loading";
import CompanyConfiguration from "./services/CompanyConfiguration";
import StateStorage from './utils/StateStorage';

class App extends Component {

  authService = new AuthenticationService();
  userService = new UserService();
  companyConfigurationService = new CompanyConfiguration();

  constructor(props) {
    super(props);
    this.state = {loading: true};
  }

  componentDidMount() {
    const state = this.state;
    if (this.authService) {
      this.companyConfigurationService.getCompanyConfigurations();
      state.loading = true;
      this.userService.getMe().then(
          data => this.setState(
              {
                loading: false,
                currentUser: data
              }),
          error => {
            const state = {loading: false};
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
            this.setState(state);
          }
      )
    } else {
      state.loading = false;
    }
    this.setState(state);
  }

  render() {
    const {loading} = this.state;
    if (loading) {
      return <Loading/>
    }
    return (
        <HashRouter>
          <Dashboard
              logoLg={<span><b>byond</b>GO</span>}
              logoSm={<span>GO!</span>}
              navbarChildren={<NavHeader {...this.props}/>}
              footerChildren={<Footer {...this.props}/>}
              initialCollapse={StateStorage.get(SIDEBAR_COLLAPSE_STORAGE)}
              sidebarMini
              sidebarChildren={<MySidebar  {...this.props}/>} theme="skin-blue">
            <Switch>
              {
                AllRoutes.map(({path, component, exact, isPrivate}, index) => {
                  return <PrivateRoute exact={exact} path={path}
                                       isPrivate={isPrivate}
                                       key={index}
                                       component={component} {...this.props}/>
                })}
            </Switch>
            <ToastContainer autoClose={2500}/>
          </Dashboard>
        </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js